<script lang="jsx">
import { caseOf, map } from "../../lib";
import StoreForm from "../../components/StoreForm.js";
import Retry from "../../components/Retry";
import storesMixin from "../../mixins/storesMixin.js";

export default {
  mixins: [storesMixin],
  data() {
    return {
      id: this.$route.params.id,
    };
  },

  created() {
    this.setStoreProviders();
    this.selectStore({ id: this.id });
    this.setStoreCategories();
  },

  render() {
    return (
      <div class="page">
        {caseOf(this.selectedStore, {
          Done: store => (
            <div>
              <header>
                <h2>
                  Edit {store.name}
                  {this.currentStep === 0 ? (
                    <span>Step 1 / 4: Set store information</span>
                  ) : this.currentStep === 1 ? (
                    <span>Step 2 / 4: Set payment</span>
                  ) : this.currentStep === 2 ? (
                    <span>Step 3 / 4: Invoicing</span>
                  ) : this.currentStep === 3 ? (
                    <span>Step 4 / 4: Set visibility settings</span>
                  ) : (
                    <span />
                  )}
                </h2>
              </header>
              <StoreForm
                context={this}
                store={store}
                storeProviders={this.storeProviders}
                action={this.updateStore}
                storeCategories={this.storeCategories}
                isNewStore={false}
              />
              <ul class="store-comments">
                {map(store.comments, comment => (
                  <li>
                    {comment.created_at}-{comment.text}
                  </li>
                ))}
              </ul>
            </div>
          ),
          Error: () => (
            <Retry refresh={() => this.selectStore({ id: this.id })} />
          ),
          _: () => (
            <div class="spinner-container">
              <div class="spinner" />
            </div>
          ),
        })}
      </div>
    );
  },
};
</script>
